import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Dashbord from "../pages/Dashbord";
import AdminLogin from "../pages/AdminLogin";
import Addcatagory from "../pages/addcatagory";
import Catagorylist from "../pages/Catagorylist";
import Updatecatagory from "../pages/Updatecatagory";
import AddShippingcharge from "../pages/AddShippingcharge";
import Shippingchargeslist from "../pages/Shippingchargeslist";
import UpdateShippingCharge from "../pages/updateShippingchargeslist";

import CouponList from "../pages/coupon/CouponList";
import CreateCoupon from "../pages/coupon/CreateCoupon";
import EditCoupon from "../pages/coupon/EditCoupon";


import PageList from "../pages/page/PageList";
import CreatePage from "../pages/page/CreatePage";
import EditPage from "../pages/page/EditPage";
import SubCategoryList from "../pages/sub_category/SubCategoryList";
import CreateSubCategory from "../pages/sub_category/CreateSubCategory";
import EditSubCategory from "../pages/sub_category/EditSubCategory";
import AddProduct from "../pages/product/AddProduct";
import ProductList from "../pages/product/ProductList";
import UpdateProduct from "../pages/product/UpdateProduct";
import Orders from "../pages/Order/Orders";
import OrderDetails from "../pages/Order/OrderDetails";

import UserProfile from "../pages/page/UserProfile";
import Users from "../pages/page/Users";
import Admins from "../pages/page/Admins";
import Blogs from "../pages/page/Blogs";
import Banner from "../pages/page/Banner";
import ShippingZone from "../pages/page/ShippingZone";
import ShopLocation from "../pages/page/ShopLocation";
import Shifts from "../pages/page/Shifts";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Dashbord />,
      },
      {
        path: "/login",
        element: <AdminLogin />,
      },
      {
        path: "/addcategory",
        element: <Addcatagory />,
      },
      {
        path: "/category-list",
        element: <Catagorylist />,
      },
      {
        path: "/updatecatagory/:id",
        element: <Updatecatagory />,
      },
      {
        path: "/sub-category/create",
        element: <CreateSubCategory />,
      },
      {
        path: "/sub-category/list",
        element: <SubCategoryList />,
      },
      {
        path: "/sub-category/edit/:id",
        element: <EditSubCategory />,
      },
      {
        path: "/addproduct",
        element: <AddProduct />,
      },
      {
        path: "/updateproduct/:id",
        element: <UpdateProduct />,
      },
      {
        path: "/productlist",
        element: <ProductList />,
      },
      {
        path: "/page/create",
        element: <CreatePage />,
      },
      {
        path: "/page/list",
        element: <PageList />,
      },
      {
        path: "/page/edit/:id",
        element: <EditPage />,
      },
      // Coupons
      {
        path: "/coupons",
        element: <CouponList />,
      },
      {
        path: "/coupon/create",
        element: <CreateCoupon />,
      },
      {
        path: "/coupon/edit/:id",
        element: <EditCoupon />,
      },
      {
        path: "/addshippingcharge",
        element: <AddShippingcharge />,
      },
      {
        path: "/shippingchargeslist",
        element: <Shippingchargeslist />,
      },
      {
        path: "/updateshipping/:id",
        element: <UpdateShippingCharge />,
      },
      {
        path: '/orders',
        element: <Orders />
      },
      {
        path: '/order-details/:id',
        element: <OrderDetails />
      },
      {
        path: "/user-profile",
        element: <UserProfile />
      },
      {
        path: "/users",
        element: <Users />
      },
      {
        path: "/admins",
        element: <Admins />
      },
      {
        path: "/blogs",
        element: <Blogs />
      },
      {
        path: "/banner",
        element: <Banner />
      },
      {
        path: "/shipping-zone",
        element: <ShippingZone />
      },
      {
        path: "/shop-location",
        element: <ShopLocation />
      },
      {
        path: "/shifts",
        element: <Shifts />
      }
    ],
  },
]);

export default router;
